// extracted by mini-css-extract-plugin
export var banner = "_sz-0";
export var settingRow = "_sz-2";
export var titleIcon = "_sz-1";